import React, { forwardRef } from 'react'
import { Input } from '@mantine/core'
import CheckComp from './Check'
import TitleComp from './Title'

// 通用字段设置
const Render = function ({ register, children }) {
  return (
    <>
      {/* 少了一个hint配置项（placeholder） */}
      <TitleComp title="字段名称">
        <Input {...register('title')} />
      </TitleComp>
      <TitleComp title="引导文字">
        <Input {...register('intro')} />
      </TitleComp>
      <TitleComp title="字段说明">
        <Input {...register('description')} />
      </TitleComp>
      {children}
      <TitleComp title="查看编辑权限">
        <CheckComp
          register={register}
          registerName="readonly"
          label="是否只读"
          tipLabel="答题人能看到此项，但不能编辑。"
        />
        <CheckComp
          register={register}
          registerName="hidden"
          label="是否隐藏"
          tipLabel="答题人不能看到此项，仅供系统调用。"
        />
      </TitleComp>
    </>
  )
}

export default forwardRef(Render)
